import {Application} from "./pixi-app.service.interface";
import {IPixiLibWrapper} from "./pixi-lib-wrapper/pixi-lib-wrapper.interface";

export type AddDisposeActionFn = (action: () => void) => void;
interface IAnimationRendererDefArgs<T extends string, U> {
    pixiApp: Application<HTMLCanvasElement>,
    resources: Record<T, U>,
    pixiLibWrapper: IPixiLibWrapper;
    addDisposeAction: AddDisposeActionFn;
}
type AnimationDef<T extends string, U> = (stuff: IAnimationRendererDefArgs<T, U>) => (void | (() => void));

export interface IAnimationRenderer<T extends string, U> {
    render: AnimationDef<T, U>;
    dispose?(): void;
}

export enum AnimationStatus {
    Idle,
    Loading,
    Failed,
    Aborted,
    Running,
    Disposed
}

interface IPixiAnimationPromiseResultSuccess {
    status: AnimationStatus.Running;
    canvas: HTMLCanvasElement;
}
interface IPixiAnimationPromiseResultOther {
    status: AnimationStatus.Failed | AnimationStatus.Aborted | AnimationStatus.Disposed;
    canvas?: undefined;
}

export type IPixiAnimationPromiseResult = IPixiAnimationPromiseResultSuccess | IPixiAnimationPromiseResultOther;
